export const vsLookupManagementServiceName = "contactBookLookupManagementService";
export const vsLookupManagementServiceProviderName = `${vsLookupManagementServiceName}Provider`;
